<member-direct-skip-button (click)="skipToContent()"></member-direct-skip-button>
<clients-grid-container>
    <clients-grid-layout
        [ngClass]="{'main-client-container': true, 'next-gen': nextGen | async}"
        [layout]="(nextGen | async) ? LAYOUT.COLUMN : LAYOUT.ROW"
        [layoutXs]="LAYOUT.COLUMN"
        [layoutSm]="LAYOUT.COLUMN"
        [layoutMd]="(nextGen | async) ? LAYOUT.COLUMN : LAYOUT.ROW"
        [customStyles]="{ 'min-height': 'inherit' }"
    >
        <div class="sidebar" role="complementary"><member-direct-header></member-direct-header></div>
        <div #mainView class="main-view" role="main" tabindex="-1"><router-outlet></router-outlet></div>
        <div *ngIf="nextGen | async" class="footer">
            <member-direct-footer></member-direct-footer>
        </div>
    </clients-grid-layout>
</clients-grid-container>

<clients-bar-loader [fullScreen]="true"></clients-bar-loader>
